import React from 'react';
import styles from './BillableChartSkeleton.module.css';

const BillableChartSkeleton: React.FC = () => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.title}></div>
      </div>
      
      <div className={styles.chartContainer}>
        <div className={styles.chart}>
          <div className={styles.doughnut}></div>
        </div>
      </div>
      
      <div className={styles.legendContainer}>
        <div className={styles.legendItem}>
          <span className={styles.legendColor}></span>
          <span className={styles.legendText}></span>
        </div>
        <div className={styles.legendItem}>
          <span className={styles.legendColor}></span>
          <span className={styles.legendText}></span>
        </div>
      </div>
    </div>
  );
};

export default BillableChartSkeleton;
